import React, { useEffect, useState } from 'react';
import { GetLabelColor } from '../../lib/helpers';
import postObject from '../../lib/postObject';
import { Container, Dimmer, Table, Card, Button, Avatar, Page, Tag } from "tabler-react";
import { useLocation, useHistory } from 'react-router-dom';
import Chat from '../../components/chat';
import PhotoModal from '../../components/modal/photoModal';
import SearchInput from '../../components/searchInput';

const RecordsTable = ({ headers, records, openMainModal, loading, reload, children, searchQuery, onSearch }) => {
    const [hidden, setHidden] = useState(true);
    const [chatUser, setChatUser] = useState(null)
    const { pathname } = useLocation()
    const [modalPhoto, setModalPhoto] = useState(null)
    const history = useHistory()

    useEffect(() => {
        // var location = window.location.href
        if (pathname.includes('placed'))
            setHidden(true)
        else
            setHidden(false)

        document.body.className = 'pendingclass';
        return () => { document.body.className = ''; }
    }, [pathname])

    const submitAccept = (id) => {
        postObject(`trips/${id}/approve`, {}).then(() => reload())
    }

    const submitReject = (id) => {
        postObject(`trips/${id}/reject`, {}).then(() => reload())
    }

    return (
        <Container>
            {modalPhoto &&
                <PhotoModal photo={modalPhoto} close={() => setModalPhoto(null)} />
            }

            <Page.Header>
                <Page.Title>Trips</Page.Title>
            </Page.Header>
            <Card className="">
                <Dimmer active={loading} loader={loading}>
                    <Card.Header>
                        <Card.Options>
                            <SearchInput value={searchQuery} onSubmit={onSearch} />
                        </Card.Options>
                    </Card.Header>

                    {children}

                    {!loading && records.length < 1 ? (
                        <div className="alert alert-primary m-0">
                            No Trips to show!
                        </div>
                    ) : (
                        <div className="table-responsive-wrapper">
                            <Table hasOutline striped>
                                <Table.Header>
                                    {headers.map((head, i) => (
                                        <Table.ColHeader key={`tableHeader-${i}`}>{head}</Table.ColHeader>
                                    ))}
                                    <Table.ColHeader>Actions</Table.ColHeader>
                                </Table.Header>
                                <Table.Body>
                                    {records.map((r, i) => (
                                        <Table.Row key={i}>
                                            {Object.keys(r).map((k, idx) => {
                                                if (k.includes('ID')) { return null }
                                                if (k === 'imgUrl') {
                                                    return (
                                                        <Table.Col key={`${i}-${k}`}>
                                                            <Avatar 
                                                                size="sm" 
                                                                imageURL={r['imgUrl']}
                                                                onClick={() => setModalPhoto(r['imgUrl'])} 
                                                                className="clickable" 
                                                            />
                                                        </Table.Col>
                                                    );
                                                } else if (k === 'state') {
                                                    return (
                                                        <Table.Col key={`${i}-${k}`}>
                                                            <Tag color={GetLabelColor(r[k])}>
                                                                {r[k]}
                                                            </Tag>
                                                        </Table.Col>
                                                    );
                                                }
                                                else if (k === 'departureDate') {
                                                    return (
                                                        <Table.Col key={`${i}-${k}`}>
                                                            <span className="blue"> {r[k]}</span>
                                                        </Table.Col>
                                                    )
                                                }
                                                else {
                                                    return (<Table.Col key={`${i}-${k}`}>{r[k]}</Table.Col>);
                                                }
                                            })}
                                            <Table.Col>
                                                <div className="actions-wrap">
                                                    <Button
                                                        outline
                                                        color="secondary"
                                                        size="sm"
                                                        onClick={() => openMainModal('trip-view', r['ID'])}
                                                    >
                                                        View
                                                    </Button>

                                                    <Button
                                                        outline
                                                        color="danger"
                                                        className="ml-2 mr-2"
                                                        size="sm"
                                                        onClick={() => openMainModal('trips--delete', r['ID'], reload)}
                                                    >
                                                        Delete
                                                    </Button>

                                                    <Button
                                                        outline
                                                        color="secondary"
                                                        className="ml-2"
                                                        size="sm"
                                                        onClick={() => setChatUser({ ID: r['userID'], username: r['username'], photo: r['imgUrl'] })}
                                                    >
                                                        Chat
                                                    </Button>

                                                    <Button
                                                        outline
                                                        color="success"
                                                        className={`ml-2 ${hidden ? 'show-action' : 'hidden-action'}`}
                                                        size="sm"
                                                        onClick={() => submitAccept(r['ID'])}
                                                    >
                                                        Accept
                                                    </Button>

                                                    <Button
                                                        outline
                                                        color="warning"
                                                        className={`ml-2 ${hidden ? 'show-action' : 'hidden-action'}`}
                                                        size="sm"
                                                        onClick={() => submitReject(r['ID'])}
                                                    >
                                                        Reject
                                                    </Button>

                                                    <Button
                                                        outline
                                                        color="secondary"
                                                        className={`ml-2 ${pathname.includes('progress') ? 'show-action' : 'hidden-action'}`}
                                                        size="sm"
                                                        onClick={() => history.push(`/trips/tripShipments/${r['ID']}`)}
                                                    >
                                                        Matched
                                                    </Button>
                                                </div>
                                            </Table.Col>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </div>
                    )}
                </Dimmer>
            </Card>

            {chatUser && <Chat user={chatUser} onClose={() => setChatUser(null)} />}

        </Container>
    );
}

export default RecordsTable;